// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y4V-","icon":"styles_icon__aw5lq"};